import Pagination from '@react/shared/components/Pagination';
import Helmet from 'next/head';
import { object } from 'proptypes';
import React from 'react';
import { host } from 'sly/config';

const SearchPagination = ({ pagination, children }) => {
  const { current, total, start, end, count, basePath, linkRel } = pagination;

  return (
    <>
      <Helmet>
        {linkRel.next && <link rel='next' href={`${host}${linkRel.next}`} />}
        {linkRel.prev && <link rel='prev' href={`${host}${linkRel.prev}`} />}
      </Helmet>

      <div
        className='flex flex-col items-center py-l px-0 pb-xl md:pb-l'
        data-testid='SearchPagination'
      >
        {total > 0 && (
          <div className='mb-l' data-testid='SearchPaginationPagination'>
            <Pagination
              basePath={basePath}
              pageParam='page-number'
              current={current}
              total={total}
              eventProps={{
                cta: 'View page of search',
                location: 'search list',
              }}
            />
          </div>
        )}
        {!!count && (
          <div
            className='mb-l hidden md:block'
            data-testid='SearchPaginationText'
          >
            {start} - {end} of {count} results
          </div>
        )}
        {children}
      </div>
    </>
  );
};

SearchPagination.propTypes = {
  currentFilters: object,
  pagination: object,
};

export default SearchPagination;
